import React, { ReactNode } from 'react'
import styles from './profilePanel.module.scss'
import InfoBoxContainer from 'components/generic/InfoBoxContainer'
import cx from 'classnames'
import { ClassNameProps, ClassNamesProps } from 'types/utilities'

type ClassKeys = 'container' | 'title' | 'subtitle' | 'content'

interface ProfilePanelProps extends ClassNameProps, ClassNamesProps<ClassKeys> {
  title: ReactNode
  subtitle?: string
  children?: ReactNode
}

const ProfilePanel = ({ title, subtitle, className, classNames, children }: ProfilePanelProps) => {
  return (
    <InfoBoxContainer
      className={cx(styles.container, className, classNames?.container)}
      as='section'
    >
      {typeof title === 'string' ? (
        <h2 className={cx(styles.title, classNames?.title)}>{title}</h2>
      ) : (
        title
      )}
      {subtitle && <p className={cx(styles.subtitle, classNames?.subtitle)}>{subtitle}</p>}
      <div className={cx(styles.content, classNames?.content)}>{children}</div>
    </InfoBoxContainer>
  )
}

export interface DataListItem {
  label: string
  value: string
  ariaLabelValue?: string
}

interface DataListProps {
  items: DataListItem[]
}

const DataList = ({ items }: DataListProps) => {
  return (
    <table className={styles.dataList}>
      <tbody>
        {items.map((item, index) => (
          <tr key={index} className={styles.dataListItem}>
            <th className={styles.dataListItemLabel}>{item.label}</th>
            <td className={styles.dataListItemValue} aria-label={item?.ariaLabelValue}>
              {item.value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

ProfilePanel.DataList = DataList

export default ProfilePanel
